import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { AngularUiModule } from '@univacity/angular/ui';
import { NzBadgeModule } from 'ng-zorro-antd/badge';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { MessagesFacade } from '../../../+state/messages/messages.facade';

@Component({
  selector: 'un-message-threads-filters',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NzDropDownModule,
    AngularUiModule,
    NzBadgeModule,
  ],
  templateUrl: './message-threads-filters.component.html',
  styleUrls: ['./message-threads-filters.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MessageThreadsFiltersComponent {
  control = new FormControl();
  constructor(public facade: MessagesFacade) {}
}
